var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 40,
    viewBox: "0 0 54 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 40,
    rx: 7,
    fill: "#FFC403"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1946 17.0376V22.5166H22.696V19.4435L21.6951 20.9244H20.9107L19.8102 19.4435V22.5166H18.4404V17.0376H19.8219L21.4024 19.1859L22.819 17.0376H24.1946ZM24.6277 18.2786V17.0376H29.7438V18.2786H27.9526V22.5166H26.4248V18.2786H24.6277ZM35.3809 17.0376V22.5166H34.1224L31.5468 19.3849V22.5166H30.177V17.0376H31.5409L34.0053 20.0581V17.0376H35.3809Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8585 28.2415C22.4332 28.2415 18.2595 27.4161 15.1102 25.9117C11.8146 24.3371 10 22.1946 10 19.8707C10 17.5468 11.8146 15.4044 15.1102 13.8298C18.2595 12.3254 22.4332 11.5 26.8585 11.5C31.2839 11.5 35.4576 12.3254 38.6068 13.8298C41.9024 15.4044 43.7171 17.5468 43.7171 19.8707C43.7171 22.1946 41.9024 24.3371 38.6068 25.9117C35.4576 27.4161 31.2839 28.2415 26.8585 28.2415ZM26.8585 12.7351C22.6088 12.7351 18.6283 13.5195 15.6429 14.9478C12.8039 16.3059 11.2351 18.0561 11.2351 19.8766C11.2351 21.6971 12.798 23.4473 15.6429 24.7995C18.6283 26.2278 22.6146 27.0122 26.8585 27.0122C31.1024 27.0122 35.0888 26.2278 38.0741 24.7995C40.9132 23.4473 42.4819 21.6912 42.4819 19.8766C42.4819 18.062 40.919 16.3059 38.0741 14.9537C35.0888 13.5195 31.1083 12.7351 26.8585 12.7351Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.34638512c7c2df1b42ccc5e38a9cf43c.svg";
export { ForwardRef as ReactComponent };